<template>
    <div class="modal_delete">
        <p>削除してよろしいですか？</p>
        <p>※一度削除すると元に戻せません。</p>
        <div class="delete_btns">
            <Button class="cancelBtn" @click="canceled">キャンセル</Button>
            <Button class="btn deleteBtn" @click="deleted">削除</Button>
        </div>
        
    </div>
</template>

<script>
export default {
    name: 'DeleteModal',
    data() {
        return {};
    },
    methods: {
        canceled: function() {
            this.$emit('canceled');
        },
        deleted: function() {
            this.$emit('deleted');
        }
    }
}
</script>
<style scoped lang="sass">
.modal_delete
    padding: 24px
    p
        font-size: 1.6rem
    .deleteBtn
        width: 100px
        background-color: #ff5252
        border: 1px solid #ff5252
    .cancelBtn
        width: 100px
        background-color: #ccc
        border: 1px solid #ccc
    .delete_btns
        margin-top: 40px
        display: flex
        justify-content: space-evenly
</style>